module.exports = __webpack_public_path__ + "static/img/bv.83e56e13.svg";